import { render, staticRenderFns } from "./ResourceConfig.vue?vue&type=template&id=571fba24&scoped=true"
import script from "./ResourceConfig.vue?vue&type=script&lang=js"
export * from "./ResourceConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571fba24",
  null
  
)

export default component.exports